import {useParams} from 'react-router-dom';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {AttachmentClassificationForm} from 'src/app/attachment-classifications/AttachmentClassificationForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const EditAttachmentClassificationPage = () => {
  useSetDocumentTitle('Edit Attachment Classification');
  const {id} = useParams();

  return (
    <ContentWrapper>
      {id !== undefined && (
        <AttachmentClassificationForm id={Number(id)} mode="edit" />
      )}
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.AttachmentClassificationEdit(':id'),
  element: <EditAttachmentClassificationPage />,
  module: ModuleEnum.AttachmentClassifications,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default EditAttachmentClassificationPage;
